import Store from 'redux/store';
import {
	FETCH_POINTS_CASH_CONFIG,
	FETCH_POINTS_CASH_CONFIG_FAIL,
	FETCH_POINTS_CASH_CONFIG_SUCCESS,
	FETCH_POINTS_CASH_INSTALLMENTS,
	FETCH_POINTS_CASH_INSTALLMENTS_FAIL,
	FETCH_POINTS_CASH_INSTALLMENTS_SUCCESS,
	FETCH_CREATE_PURCHASE,
	FETCH_CREATE_PURCHASE_FAIL,
	FETCH_CREATE_PURCHASE_SUCCESS,
	FETCH_BRASPAG_AUTHORIZATION,
	FETCH_BRASPAG_AUTHORIZATION_SUCCESS,
	FETCH_BRASPAG_AUTHORIZATION_FAIL,
} from 'redux/Reducers/Checkout/CheckoutReducer';

import { cloudloyalty } from '../clients';
import { isObjectEmpty } from 'Utils';

const FetchPaymentConfig = async (
	User,
	finallyCallback = () => {},
	{ segment }
) => {
	Store.dispatch({ type: FETCH_POINTS_CASH_CONFIG });
	cloudloyalty(User)
		.get(`/v1/purchases/Pointcash/1`)
		.then((response) => {
			Store.dispatch({
				type: FETCH_POINTS_CASH_CONFIG_SUCCESS,
				payload: {
					...response,
				},
			});
		})
		.catch((e) => {
			Store.dispatch({
				type: FETCH_POINTS_CASH_CONFIG_FAIL,
				error: e,
			});
		})
		.finally(() => {
			finallyCallback();
		});
};
export default FetchPaymentConfig;

// FETCH_POINTS_CASH_INSTALLMENTS
export const CalculateInstallments = async (
	User,
	finallyCallback = () => {},
	payload = {}
) => {
	Store.dispatch({ type: FETCH_POINTS_CASH_INSTALLMENTS });
	cloudloyalty(User)
		.post(`/v1/purchases/CalculateInstallment`, payload)
		.then((response) => {
			Store.dispatch({
				type: FETCH_POINTS_CASH_INSTALLMENTS_SUCCESS,
				payload: {
					...response,
				},
			});
		})
		.catch((e) => {
			Store.dispatch({
				type: FETCH_POINTS_CASH_INSTALLMENTS_FAIL,
				error: e,
			});
		})
		.finally(() => {
			finallyCallback();
		});
};


/**
 * Extracts all the string keys and their corresponding values from an object.
 * @param {Object} objeto - The object to extract string keys from.
 * @returns {Array} - An array of objects containing the string keys and their values.
 */
function extractStringsKeys(objeto) {
  const listaChavesString = [];
  function percorrer(obj) {
    for (const chave in obj) {
      if (obj.hasOwnProperty(chave)) {
        const valor = obj[chave];

        if (typeof valor === 'string') {
					if (/[a-zA-Z]/.test(valor)) {
						listaChavesString.push({ chave, valor });
					}
        } else if (typeof valor === 'object' && valor !== null) {
          percorrer(valor);
        }
      }
    }
  }
  percorrer(objeto);
  return listaChavesString;
}

export const CreatePurchase = async (
	User,
	finallyCallback = () => {},
	payload = {}
) => {
	Store.dispatch({ type: FETCH_CREATE_PURCHASE });
	let cleanCreditPayload = {};

	payload &&
		!isObjectEmpty(payload) &&
		payload?.cardNumber &&
		(cleanCreditPayload = {
			creditCardPayment: payload,
		});
	const cleanPayload = {
		channelType: 'ONLINE',
		...cleanCreditPayload,
	};

	cloudloyalty(User)
		.post(`/v1/purchases`, cleanPayload)
		.then((response) => {
			Store.dispatch({
				type: FETCH_CREATE_PURCHASE_SUCCESS,
				payload: {
					...response,
				},
			});
		})
		.catch((e) => {
			const data = e.response.data;
			let resultado = extractStringsKeys(data);
			resultado = resultado.reverse();

			Store.dispatch({
				type: FETCH_CREATE_PURCHASE_FAIL,
				error: resultado[0].valor,
				payload: {
					data
				}
			});
		})
		.finally(() => {
			finallyCallback();
		});
};

//FETCH_BRASPAG_AUTHORIZATION
///v1/purchases/3DSToken
export const getBraspagAuthorizationToken = async (
	User,
	finallyCallback = () => {},
	payload = {}
) => {
	Store.dispatch({ type: FETCH_BRASPAG_AUTHORIZATION });

	cloudloyalty(User)
		.post(`/v1/purchases/3DSToken`, {})
		.then((response) => {
			Store.dispatch({
				type: FETCH_BRASPAG_AUTHORIZATION_SUCCESS,
				payload: {
					...response,
				},
			});
		})
		.catch((e) => {
			Store.dispatch({
				type: FETCH_BRASPAG_AUTHORIZATION_FAIL,
				error: e,
			});
		})
		.finally(() => {
			finallyCallback();
		});
};
